export default "__VITE_ASSET__C1Bkh7hn__"